/* Neu Appliance Outlet — recommendation rails from the live in-stock index (tasks 86e2f3phv, 86e2f3u94).
   Shopify's native /recommendations/products returns sold-out / off-category / thin results for this
   catalog. Instead we build "Similar Appliances" (PDP) and "You may also like" (cart) from
   filter-index.json, which contains ONLY in-stock, published, categorized products with connectors,
   services and warranties already excluded. Same-category matching, in stock only.

   Hooks (any element):
     data-neu-recs="pdp"   + data-neu-recs-cat="WDSET"  data-neu-recs-exclude="<productId>"
     data-neu-recs="cart"  (categories + exclusions read live from /cart.js; also excludes New in Box)
     data-neu-recs-index="<filter-index.json url>"   data-neu-recs-limit="8" */
(function () {
  if (window.__neuRecs) return;
  window.__neuRecs = true;

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function mtrim(n) { return money(n).replace('.00', ''); }   // task 86e2xdz6w: drop the ".00"
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var BADGE_C = { scratch: { bc: 'var(--c-scratch)', bt: '#fff' }, open: { bc: 'var(--c-open)', bt: 'var(--navy)' }, refurb: { bc: 'var(--orange)', bt: '#fff' }, new: { bc: 'var(--c-newbox)', bt: '#fff' } };
  function catOf(e) { return (e.f && e.f.category && e.f.category[0]) ? String(e.f.category[0]).toUpperCase() : ''; }

  // Tag-overlap scoring: how "similar" candidate e is to the current product (self).
  function shared(a, b) { if (!a || !b) return 0; var n = 0; for (var i = 0; i < a.length; i++) { if (b.indexOf(a[i]) >= 0) n++; } return n; }
  function overlap(self, e) {
    var sf = self.f || {}, ef = e.f || {};
    // subcategory (style) matters most, then colour, then width — most overlapping wins.
    return shared(sf.style, ef.style) * 3 + shared(sf.color, ef.color) * 2 + shared(sf.width, ef.width);
  }

  function card(p) {
    var b = BADGE_C[p.cond] || BADGE_C.scratch;
    var hasCap = p.cap && p.cap > p.price;
    var off = hasCap ? Math.round((p.cap - p.price) / p.cap * 100) : 0;
    var save = hasCap ? ('You save ' + mtrim(p.cap - p.price)) : '';
    var was = hasCap ? mtrim(p.cap) : '';
    return '<article class="pcard" data-cond="' + esc(p.cond) + '"' +
      ' data-href="' + esc(p.url) + '" data-title="' + esc(p.title) + '" data-img="' + esc(p.img) + '"' +
      ' data-brand="' + esc(p.vendor) + '" data-price="' + esc(money(p.price)) + '"' +
      (was ? ' data-was="' + esc(was) + '"' : '') + (save ? ' data-save="' + esc(save) + '"' : '') +
      ' data-badge="' + esc(p.badge) + '">' +
      '<div class="pcard__media pcard__media--photo">' +
      (function () { var u = window.NEU_BADGE_URL && window.NEU_BADGE_URL(p.cond, p.badge); return u ? '<img class="pcard__badge-img" src="' + u + '" alt="' + esc(p.badge) + '" loading="lazy">' : ''; })() +
      '<button class="pcard__fav" type="button" aria-label="Save to wishlist"><svg class="ic ic--22"><use href="#i-heart"></use></svg></button>' +
      '<a class="pcard__imglink" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' + (p.img2 ? '<img class="pcard__img-alt" src="' + esc(p.img2) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
      '</div><div class="pcard__body"><span class="pcard__brand">' + esc(p.vendor) + '</span>' +
      (p.model ? '<span class="pcard__model">' + esc(p.model) + '</span>' : '') +
      '<h3 class="pcard__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      (p.sku ? '<div class="pcard__item">Item # ' + esc(p.sku) + '</div>' : '') +
      '<div class="pcard__price"><b>' + mtrim(p.price) + '</b>' + (hasCap ? '<s>' + mtrim(p.cap) + '</s><span class="pcard__off">' + off + '% OFF</span>' : '') + '</div>' +
      (save ? '<span class="pcard__save">' + save + '</span>' : '') +
      '<div class="pcard__actions"><a class="btn btn--navy pcard__shop" href="' + esc(p.url) + '">Shop Now</a>' +
      '<div class="pcard__atc"><button type="button" class="pcard__cart" data-neu-rec-add data-url="' + esc(p.url) + '" aria-label="Add ' + esc(p.title) + ' to cart"><svg class="ic ic--22"><use href="#i-cart"></use></svg></button></div>' +
      '</div></div></article>';
  }

  // Cart-drawer section ids so /cart/add.js returns rendered section HTML for Horizon to morph in.
  function cartSectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (c) {
      var id = c.dataset && c.dataset.sectionId; if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  function notifyCartUpdated(resp) {
    var ev; try { ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true }); }
    catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('shopify:cart:lines-update', true, false, null); }
    ev.action = 'add'; // let <cart-drawer-component auto-open> pop the drawer, like a native add
    ev.promise = Promise.resolve({ detail: resp || {} });
    document.dispatchEvent(ev);
  }
  // Orange quick-add on a rec card. The index has no variant id, so resolve the first available
  // variant from {url}.js, then add via /cart/add.js and let Horizon morph in the cart drawer.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-neu-rec-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    btn.disabled = true; btn.classList.add('is-loading');
    function done() { btn.disabled = false; btn.classList.remove('is-loading'); }
    fetch(btn.getAttribute('data-url') + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var vs = (prod && prod.variants) || [], v = null;
      for (var i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
      if (!v) v = vs[0];
      if (!v) { done(); return; }
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: cartSectionIds(), sections_url: location.pathname })
      }).then(function (r) { return r.json(); }).then(function (resp) { notifyCartUpdated(resp); done(); });
    }).catch(function () { done(); });
  });

  function hide(box) { var s = box.closest('section'); if (s) s.style.display = 'none'; else box.style.display = 'none'; }

  function render(box, index, opt) {
    var limit = parseInt(box.getAttribute('data-neu-recs-limit'), 10) || 8;
    var hasCats = Object.keys(opt.wantCats).length > 0;
    if (!hasCats) { hide(box); return; } // no category context -> don't show random products
    var picks = index.filter(function (e) {
      if (opt.excludeIds[String(e.id)]) return false;
      if (opt.excludeNew && e.cond === 'new') return false;
      return !!opt.wantCats[catOf(e)];
    });
    if (opt.self) {
      // Rank by tag overlap with the current product (subcategory > colour > width); freshest breaks ties.
      picks.forEach(function (e) { e.__score = overlap(opt.self, e); });
      picks.sort(function (a, b) { return (b.__score - a.__score) || ((b.added || 0) - (a.added || 0)); });
    } else {
      picks.sort(function (a, b) { return (b.added || 0) - (a.added || 0); }); // freshest first
    }
    picks = picks.slice(0, limit);
    if (!picks.length) { hide(box); return; }
    box.innerHTML = picks.map(card).join('');
    if (window.neuFillStars) window.neuFillStars(box);
    if (window.neuWlSync) window.neuWlSync(); // reflect already-saved items on the new cards' hearts
  }

  function run() {
    var boxes = document.querySelectorAll('[data-neu-recs]');
    if (!boxes.length) return;
    var indexUrl = boxes[0].getAttribute('data-neu-recs-index');
    if (!indexUrl) return;
    fetch(indexUrl).then(function (r) { return r.json(); }).then(function (index) {
      var byId = {};
      index.forEach(function (e) { byId[String(e.id)] = e; });
      boxes.forEach(function (box) {
        var mode = box.getAttribute('data-neu-recs');
        if (mode === 'cart') {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var cats = {}, ids = {};
            (cart.items || []).forEach(function (it) {
              var pid = String(it.product_id); ids[pid] = 1;
              var e = byId[pid]; if (e) { var c = catOf(e); if (c) cats[c] = 1; }
            });
            render(box, index, { wantCats: cats, excludeIds: ids, excludeNew: true });
          }).catch(function () { hide(box); });
        } else {
          var wantCats = {};
          (box.getAttribute('data-neu-recs-cat') || '').split(',').forEach(function (c) { c = c.trim().toUpperCase(); if (c) wantCats[c] = 1; });
          var ids = {}, firstId = '';
          (box.getAttribute('data-neu-recs-exclude') || '').split(',').forEach(function (id) { id = id.trim(); if (id) { ids[id] = 1; if (!firstId) firstId = id; } });
          var self = firstId ? byId[firstId] : null;
          render(box, index, { wantCats: wantCats, excludeIds: ids, excludeNew: false, self: self });
        }
      });
    }).catch(function () { boxes.forEach(hide); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
